import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";

import { signIn, getUserProfile, changePassword } from "../../services/auth";
import UserService from "../../services/user";

import * as userActionCreators from "../../actions/user";
import * as authActionCreators from "../../actions/auth";
import jwtDecode from "jwt-decode";

import acHealthLogo from "../../resources/images/logo.png";
import onBoardingImageOne from "../../resources/images/onBoarding/one.png";
import onBoardingImageTwo from "../../resources/images/onBoarding/two.png";
import onBoardingImageThree from "../../resources/images/onBoarding/three.png";
import AssignmentIndOutlinedIcon from "@material-ui/icons/AssignmentIndOutlined";
import PermIdentityOutlinedIcon from "@material-ui/icons/PermIdentityOutlined";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";

import "../../resources/styles/LoginPage.css";
import colors, { colorsV2 } from "../../styles/colors";

import IconEye from "material-ui/svg-icons/action/visibility";
import { Tooltip } from "@material-ui/core";

import config from "../../config";

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: props.email,
      password: "",
      error: null,
      activeStep: 5,
      timer: null,
      showConfirm: false,
      showPassword: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.email) {
      this.setState({
        email: nextProps.email,
      });
    }
  }

  logIn = () => {
    signIn(
      this.state.email,
      this.state.password,
      (ret) => {
        if (!_.isEmpty(ret.error)) {
          let error = `${ret.error_description}\nTrouble logging in? Contact info@ac-health.com`;
          this.setState({ error });
        } else {
          const jwt = jwtDecode(ret.id_token);

          const timeLeft = (jwt.exp - jwt.iat) * 1000; //Take difference and convert to milliseconds

          // token, refreshToken, iat, timeLeft
          localStorage.setItem("token", ret.id_token);
          localStorage.setItem("refreshToken", ret.refresh_token);
          localStorage.setItem("iat", jwt.iat);
          localStorage.setItem("timeLeft", timeLeft);

          this.props.setAllAuthValues();

          // (Auth0) auth successful, get user profile by access token
          getUserProfile(
            ret.access_token,
            (ret) => {
              let profile = ret;
              let userFirstName = profile.nickname;
              let userLastName = "";
              if (profile.given_name) {
                userFirstName = profile.given_name;
                userLastName = profile.family_name;
              } else {
                userFirstName = profile["https://ac_data/given_name"];
                userLastName = profile["https://ac_data/family_name"];
              }
              let user = {
                email: ret.email,
                loginType: "auth0",
                firstName: userFirstName,
                lastName: userLastName,
                profilePhotoUrl: profile.picture,
              };
              // call server to login and get user ID
              UserService()
                .userLogin(user)
                .then((res) => {
                  if (res && res.userId != null) {
                    this.props.userLogin(user, profile, res);
                    // go to the next page
                    this.props.history.push(`/view-channels/`);
                  } else {
                    let error =
                      "Your account has been disabled -- please contact your organization's administrator or info@ac-health.com for more information";
                    this.setState({ error });
                  }
                });
            },
            (error) => {
              this.setState({ error });
            }
          );
        }
      },
      (error) => {
        this.setState({ error });
      }
    );
  };

  goToSignUpProvider = () => {
    this.props.history.push("/sign-up-provider");
  };

  goToSignUpPatient = () => {
    this.props.history.push("/sign-up-patient");
  };

  getStart = () => {
    this.setState({
      activeStep: 4,
      timer: null,
    });
    clearInterval(this.state.timer);
  };

  confirmPasswordReset() {
    let appCode =
      this.props.whiteLabelSettings.appCode != null
        ? this.props.whiteLabelSettings.appCode
        : config.appCode;
    UserService()
      .passwordReset(this.state.email, appCode)
      .then((response) => {
        if (response.msg === "ok") {
          this.setState({ showSuccess: true, showConfirm: false });
        } else {
          this.setState({
            showError: true,
            showSuccess: false,
            showConfirm: false,
          });
        }
      });
  }

  forgotPassword() {
    const emailRegex = /^[a-zA-Z0-9\+._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (_.isEmpty(this.state.email) || !emailRegex.test(this.state.email)) {
      this.setState({
        error: "Please enter the email address you used to create the account.",
      });
    } else {
      this.setState({ showConfirm: true });
    }
  }

  renderScreenOne = () => {
    return (
      <div className="login-page__main-content">
        <img src={acHealthLogo} width="40%" />
        <div>
          <h4>BE Your PATIENT’S HERO.</h4>
          <h4>100% custom exercises.</h4>
        </div>
      </div>
    );
  };

  renderNewProviderOrPaitentForm = () => {
    return (
      <div className="login-page__main-content">
        <div className="login-page__main-content__header">
          {this.props.whiteLabelSettings.isWhiteLabel && (
            <img
              alt={this.props.whiteLabelSettings.appName + " Logo"}
              src={this.props.whiteLabelSettings.logoUrl}
              width="40%"
              style={{
                maxWidth: "275px",
                maxHeight: "150px",
                borderRadius: 10,
                overflow: "hidden",
                backgroundColor: "white",
              }}
            />
          )}
          <h3>Create Account</h3>
        </div>
        <div className="login-page_create-accounts">
          {!this.props.whiteLabelSettings.isWhiteLabel && (
            <div
              onClick={() => this.goToSignUpProvider()}
              className="login-page__sign-up"
            >
              <AssignmentIndOutlinedIcon />
              <label>Create new provider account</label>
            </div>
          )}
          <div
            onClick={() => this.goToSignUpPatient()}
            className="login-page__sign-up"
          >
            <PermIdentityOutlinedIcon />
            <label>Create new patient/client account</label>
          </div>
        </div>
      </div>
    );
  };

  renderLogin = () => {
    return (
      <div className="login-page__main-content">
        <div className="login-page__main-content__header">
          {this.props.whiteLabelSettings.isWhiteLabel && (
            <img
              alt={this.props.whiteLabelSettings.appName + " Logo"}
              src={this.props.whiteLabelSettings.logoUrl}
              style={{
                maxWidth: "275px",
                maxHeight: "150px",
                borderRadius: 10,
                overflow: "hidden",
                backgroundColor: "white",
              }}
            />
          )}
          {!this.props.whiteLabelSettings.isWhiteLabel && (
            <img src={acHealthLogo} width="40%" />
          )}
          {this.props.whiteLabelSettings.isWhiteLabel && (
            <h3
              style={{
                color: this.props.whiteLabelSettings.accentColor,
                margin: 5,
              }}
            >
              {this.props.whiteLabelSettings.appName}
            </h3>
          )}
          <h3
            style={{ 
                margin: "0 0 8px 0", // margin bottom only
            }}
          >Login</h3>
        </div>
        <div className="login-page__inputs">
          <input
            placeholder="Email"
            type="email"
            className="login-page__input"
            value={this.state.email}
            style={{ marginLeft: -20 }}
            onChange={(event) =>
              this.setState({
                error: null,
                email: event.target.value,
              })
            }
          />
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flex: 1,
              justifyContent: "center",
              justifySelf: "center",
              alignContent: "center",
              alignItems: "center",
              width: "100%",
              marginTop: 20,
              padding: 0,
            }}
          >
            <input
              placeholder="Password"
              type={this.state.showPassword ? "text" : "password"}
              className="login-page__input"
              value={this.state.password}
              onChange={(event) =>
                this.setState({
                  error: null,
                  password: event.target.value,
                })
              }
            />
            <div
              style={{
                position: "relative",
                zIndex: 9999,
                left: -35,
                fontSize: 12,
              }}
            >
              <Tooltip
                id="eyeIcon"
                title="Show Password"
                style={{ margin: 0, padding: 0 }}
              >
                <IconEye
                  color="lightGrey"
                  onClick={() => {
                    const toggled = !this.state.showPassword;
                    this.setState({ showPassword: toggled });
                  }}
                />
              </Tooltip>
            </div>
          </div>
          <div className="login-page__password">
            <label
              onClick={() => this.setState({ activeStep: 6 })}
              style={{
                color: this.props.whiteLabelSettings.isWhiteLabel
                  ? this.props.whiteLabelSettings.accentColor
                  : "",
              }}
            >
              Forgot/Reset Password?
            </label>
          </div>
        </div>
        {this.state.error && (
          <p style={{ textAlign: "center" }}>{this.state.error}</p>
        )}
      </div>
    );
  };

  renderForgetPassword = () => {
    return (
      <div className="login-page__main-content">
        <div className="login-page__main-content__header">
          {this.props.whiteLabelSettings.isWhiteLabel && (
            <img
              alt={this.props.whiteLabelSettings.appName + " Logo"}
              src={this.props.whiteLabelSettings.logoUrl}
              width="40%"
              style={{
                maxWidth: "275px",
                maxHeight: "150px",
                borderRadius: 10,
                overflow: "hidden",
                backgroundColor: "white",
              }}
            />
          )}
          <h3>Forget Password</h3>
        </div>
        <div className="login-page__inputs">
          <input
            placeholder="Email"
            type="email"
            className="login-page__input"
            value={this.state.email}
            onChange={(event) =>
              this.setState({
                error: null,
                email: event.target.value,
              })
            }
          />
          {this.state.error && <p>{this.state.error}</p>}
          <button
            className="login-page__box__forget-password__btn"
            onClick={() => this.forgotPassword()}
            style={{
              backgroundColor: this.props.whiteLabelSettings.isWhiteLabel
                ? this.props.whiteLabelSettings.accentColor
                : "",
            }}
          >
            Reset Password
          </button>
        </div>
      </div>
    );
  };

  renderMainContent = () => {
    switch (this.state.activeStep) {
      case 4:
        return this.renderNewProviderOrPaitentForm();
      case 5:
        return this.renderLogin();
      case 6:
        return this.renderForgetPassword();
      default:
        break;
    }
  };

  renderLoginSectionDownPart = () => {
    return [
      <button
        className="login-page__box__get-start__btn"
        onClick={() => this.logIn()}
        disabled={_.isEmpty(this.state.email)}
        style={{
          backgroundColor: this.props.whiteLabelSettings.isWhiteLabel
            ? this.props.whiteLabelSettings.accentColor
            : "",
        }}
      >
        {" "}
        Login{" "}
      </button>,
      <label>
        Don’t have an account{" "}
        <a
          onClick={() => {
            this.setState({ activeStep: 4 });
          }}
          style={{
            color: this.props.whiteLabelSettings.isWhiteLabel
              ? this.props.whiteLabelSettings.accentColor
              : "",
          }}
        >
          Sign Up
        </a>
      </label>,
    ];
  };

  render() {
    return (
      <div
        className="login-page"
        style={{
          backgroundColor: this.props.whiteLabelSettings.isWhiteLabel
            ? this.props.whiteLabelSettings.primaryColor
            : "",
          backgroundImage: this.props.whiteLabelSettings.isWhiteLabel
            ? "none"
            : null,
        }}
      >
        <div className="login-page__box">
          {this.renderMainContent()}
          <div className="login-page__box__get-start">
            {this.state.activeStep === 5 && this.renderLoginSectionDownPart()}
            {this.state.activeStep <= 4 && (
              <label>
                Have an account ?
                <a
                  onClick={() => {
                    this.setState({ activeStep: 5, timer: null });
                    clearInterval(this.state.timer);
                  }}
                  style={{
                    color: this.props.whiteLabelSettings.isWhiteLabel
                      ? this.props.whiteLabelSettings.accentColor
                      : "",
                  }}
                >
                  {" "}
                  Login{" "}
                </a>
              </label>
            )}
            {this.state.activeStep === 6 && (
              <label>
                Back to
                <a
                  onClick={() => {
                    this.setState({ activeStep: 5, timer: null });
                    clearInterval(this.state.timer);
                  }}
                  style={{
                    color: this.props.whiteLabelSettings.isWhiteLabel
                      ? this.props.whiteLabelSettings.accentColor
                      : "",
                  }}
                >
                  {" "}
                  Login{" "}
                </a>
              </label>
            )}
            <a
              className="login-page__need-help"
              href="mailto:info@ac-health.com"
              style={{
                color: this.props.whiteLabelSettings.isWhiteLabel
                  ? this.props.whiteLabelSettings.accentColor
                  : "",
              }}
            >
              Need help?
            </a>
          </div>
        </div>
        <Dialog
          open={this.state.showConfirm}
          onClose={() => {
            this.setState({ showConfirm: false });
          }}
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <h1 style={{ fontWeight: 600, textAlign: "center" }}>
                Confirm Email
              </h1>
              Please confirm your email was entered correctly
              <h2
                style={{
                  fontWeight: 600,
                  textAlign: "center",
                  color: colors.primary,
                }}
              >
                {this.state.email}
              </h2>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                this.setState({ showConfirm: false });
              }}
              color="primary"
            >
              Cancel
            </Button>
            <Button
              onClick={() => this.confirmPasswordReset()}
              color="primary"
              autoFocus
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.showSuccess}
          onClose={() => {
            this.setState({ showSuccess: false });
          }}
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <h1 style={{ fontWeight: 600 }}>Request Sent</h1>
              If your email was found in our system you will receive a password
              reset email shortly. Please follow the instructions in the email
              to finish resetting your password.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() =>
                this.setState({
                  showError: false,
                  showConfirm: false,
                  showSuccess: false,
                  activeStep: 5,
                })
              }
              color="primary"
              autoFocus
            >
              Go Back To Login
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.showError}
          onClose={() => {
            this.setState({ showError: false });
          }}
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <h1 style={{ fontWeight: 600 }}>
                We Were Unable to Reset Your Password
              </h1>
              An error was encountered trying to reset your password, please try
              again. If problems persist please contact AC Health Support.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => this.setState({ showError: false })}
              color="primary"
              autoFocus
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

function mapStateToProps({ user, whiteLabelSettings }) {
  return {
    userId: user.userId,
    email: user.email,
    whiteLabelSettings,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...userActionCreators, ...authActionCreators },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/layout/LoginPage/Login.js